import { GameAction, GameActionTypes, favoriteError } from "./Game";
import { Dispatch } from "redux";
import { removeFromFavorite as apiRemoveFromFavorite } from "@blacknut/javascript-sdk/dist/api/removeFromFavorite";
export const removeFromFavoriteRequest = (id: string): GameAction => ({
  type: GameActionTypes.REMOVE_FROM_FAVORITE_REQUEST,
  id,
});

export const removeFromFavoriteSuccess = (gameId: string): GameAction => ({
  type: GameActionTypes.REMOVE_FROM_FAVORITE_SUCCESS,
  id: gameId,
});

export const removeFromFavorite = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    return new Promise<void>((resolve, reject) => {
      dispatch(removeFromFavoriteRequest(id));
      apiRemoveFromFavorite(id).subscribe({
        next: () => {
          dispatch(removeFromFavoriteSuccess(id));
          resolve();
        },
        error: (error) => {
          dispatch(favoriteError(id, error));
          reject(error);
        },
      });
    });
  };
};
